import { Component, inject, OnInit, signal } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { SidePanelWrapperComponent } from '@components/side-panel-wrapper/side-panel-wrapper.component';
import { AuthService } from '@services/auth.service';
import { SidePanelService } from '@services/side-panel.service';
import { ViewState } from '@utils/view-state.utils';
import { filter, firstValueFrom } from 'rxjs';

@Component({
  imports: [
    RouterOutlet,
    SidePanelWrapperComponent,
  ],
  selector: 'app-root',
  styleUrl: './app.component.scss',
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {
  protected viewState = signal<ViewState<void, string>>({ status: 'initial' });
  protected sidePanels = inject(SidePanelService).get();
  private authService = inject(AuthService);
  private router = inject(Router);
  private token!: string;

  ngOnInit(): void {
    this.setup();
  }

  protected async initialize(): Promise<void> {
    this.viewState.set({ status: 'loading' });
    try {
      await this.authService.signIn(this.token);
      this.viewState.set({ status: 'success' });
      if (this.router.routerState.snapshot.root.queryParams['token']) {
        this.router.navigate(['/dummy-simulation'], { queryParams: { token: undefined }, replaceUrl: true });
      } else {
        this.router.navigate([], { queryParams: { internal_token: undefined }, replaceUrl: true });
      }
    } catch (error) {
      this.viewState.set({ error: 'Failed to sign in', status: 'error' });
      console.error(error);
    }
  }

  private async setup(): Promise<void> {
    await firstValueFrom(this.router.events.pipe(filter((event) => event instanceof NavigationEnd)));
    const queryParams = this.router.routerState.snapshot.root.queryParams;
    const token = queryParams['token'] || queryParams['internal_token'];
    if (!token) {
      this.viewState.set({ error: 'Token is required', status: 'error' });
      return;
    }
    this.token = token;
    this.initialize();
  }
}
